import LmsEnrolmentsTable from "@/components/lms/lmsEnrolmentsTable";
import LmsStatusOverviewCard from "@/components/lms/lmsStatusOverviewCard";
import type { LmsCourseOverviewTab } from "@/components/lms/lmsCourseOverviewTypes";
import type { LmsMode } from "@/components/lms/lms.utils";
import styles from "@/routes/lms/lmsCourseOverview.module.css";

interface Props {
  activeTab: LmsCourseOverviewTab;
  courseId: string;
  enrolmentRefreshKey: number;
  mode: LmsMode;
  onCreateEnrolment: () => void;
  onEnrolmentTableRefreshed: () => void;
  onError: (error: any) => void;
  canCreateEnrolments?: boolean;
  createEnrolmentsDisabledMessage?: string;
}

export default function LmsCourseOverviewTabPanels({
  activeTab,
  courseId,
  enrolmentRefreshKey,
  mode,
  onCreateEnrolment,
  onEnrolmentTableRefreshed,
  onError,
  canCreateEnrolments,
  createEnrolmentsDisabledMessage,
}: Props) {
  return (
    <>
      {activeTab === "statistics" && (
        <div className={styles.statisticsTabContentSection}>
          <LmsStatusOverviewCard
            mode={mode}
            courseId={courseId}
            dualDisplayMode={true}
          />
        </div>
      )}

      {activeTab === "enrolments" && (
        <LmsEnrolmentsTable
          courseId={courseId}
          mode={mode}
          includeCourseColumn={false}
          onCreate={onCreateEnrolment}
          refreshKey={enrolmentRefreshKey}
          onRefreshed={onEnrolmentTableRefreshed}
          onError={onError}
          showViewCourseButton={false}
          canCreateEnrolments={canCreateEnrolments}
          createEnrolmentsDisabledMessage={createEnrolmentsDisabledMessage}
        />
      )}
    </>
  );
}
